import { DiscrepancyStatus } from "generated-graphql/graphql";

import { getDiscrepancyStatus, getStatusLabel } from "./DiscrepancyReviewDialog.helpers";

/**
 * Lifecycle states the manifest list's "Discrepancy Status" filter offers, in
 * the order a discrepancy moves through them. IGNORED is absent: dismissed rows
 * are non-discrepancies and draw no bubble, so selecting one would return
 * manifests whose Discrepancies column is blank. The backend
 * (`buildDiscrepancyStatusFilter`) drops it too, so a hand-typed
 * `discrepancyStatus:IGNORED` can't get around this.
 */
export const DISCREPANCY_STATUS_FILTER_VALUES: string[] = [
  DiscrepancyStatus.Unresolved,
  DiscrepancyStatus.Pending,
  DiscrepancyStatus.Resolved,
];

/** Filter option label, through the same map every status chip prints from. */
export function discrepancyStatusFilterLabel(value: string): string {
  return getStatusLabel(getDiscrepancyStatus({ status: value }));
}
